import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import * as internalActions from './actions';
import * as commandActions from '../command/actions';
import * as readModelActions from '../read-model/actions';
import * as viewModelActions from '../view-model/actions';

var allActions = _extends({}, internalActions, commandActions, readModelActions, viewModelActions);

var connectResolveAdvanced = function connectResolveAdvanced(Component) {
  var ConnectResolveAdvancedComponent = /*#__PURE__*/function (_React$PureComponent) {
    _inheritsLoose(ConnectResolveAdvancedComponent, _React$PureComponent);

    function ConnectResolveAdvancedComponent() {
      return _React$PureComponent.apply(this, arguments) || this;
    }

    var _proto = ConnectResolveAdvancedComponent.prototype;

    _proto.render = function render() {
      return /*#__PURE__*/React.createElement(Component, _extends({
        actions: allActions
      }, this.props));
    };

    return ConnectResolveAdvancedComponent;
  }(React.PureComponent);

  hoistNonReactStatic(ConnectResolveAdvancedComponent, Component);
  return ConnectResolveAdvancedComponent;
};

export default connectResolveAdvanced;
//# sourceMappingURL=connect-resolve-advanced.js.map